import React from 'react';
import { ReactComponent as UserIcon } from 'assets/icons/ui/user.svg';
import { FsComponentSize } from 'globals/types';
import {
  NameBox,
  Avatar,
  Name,
  ContentBox,
  SubContent,
} from './FsAvatarWithName.style-elements';

interface FsAvatarWithNameProps {
  color?: string;
  subContent?: string;
  size?: FsComponentSize.M | FsComponentSize.S;
}

const FsAvatarWithName: React.FC<FsAvatarWithNameProps> = ({
  color,
  children,
  subContent,
  size,
}) => {
  const defaultSize = size || FsComponentSize.M;
  return (
    <NameBox>
      <Avatar color={color} size={defaultSize}>
        <UserIcon width={size === FsComponentSize.S ? 8 : undefined} />
      </Avatar>
      <ContentBox size={defaultSize}>
        <Name size={defaultSize}>{children}</Name>
        {subContent && <SubContent>{subContent}</SubContent>}
      </ContentBox>
    </NameBox>
  );
};

export default FsAvatarWithName;
